import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import * as common from "./common/common";

import "./App.css";

import Layout from "./components/Menu/Layout";

import Login from "./pages/Login";
import Home from "./pages/Home";

import TicketSummary from "./pages/Dashboard/TicketSummary";
import AgentKPI from "./pages/Dashboard/AgentKPI";

import TicketList from "./pages/Ticket/TicketList";
import NewTicket from "./pages/Ticket/NewTicket";
import ViewTicket from "./components/Ticket/TicketList/ViewTicket";

import TicketListHistory from "./pages/Report/TicketListHistory";

import Policy from "./pages/MasterSetup/Policy";
import Organization from "./pages/MasterSetup/Organization";
import System from "./pages/MasterSetup/System";
import TicketCategory from "./pages/MasterSetup/TicketCategory";
import TicketPriorityType from "./pages/MasterSetup/TicketPriorityType";
import TicketStatusType from "./pages/MasterSetup/TicketStatusType";
import ServerEnv from "./pages/MasterSetup/ServerEnv";
import ServerConnType from "./pages/MasterSetup/ServerConnType";

import Users from "./pages/AccessManagement/Users";
import Roles from "./pages/AccessManagement/Roles";
import Permissions from "./pages/AccessManagement/Permissions";
import SystemAuthority from "./components/AccessManagement/Users/SystemAuthority";

import SystemInfo from "./pages/SystemInfo/SystemInfo";

function App() {
  const [cookies, removeCookies] = useCookies([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location === common.c_getWebUrl() + "Login") {
      removeCookies();
    }
  }, [cookies.EMAIL, navigate]);

  return (
    <div>
      {!cookies.EMAIL ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/Home" element={<Home />} />

            <Route path="/TicketSummary" element={<TicketSummary />} />
            <Route path="/AgentKPI" element={<AgentKPI />} />

            <Route path="/TicketList" element={<TicketList />} />
            <Route path="/TicketListHistory" element={<TicketListHistory />} />
            <Route path="/ViewTicket" element={<ViewTicket />} />
            <Route path="/NewTicket" element={<NewTicket />} />

            <Route path="/Users" element={<Users />} />
            <Route path="/Roles" element={<Roles />} />
            <Route path="/Permissions" element={<Permissions />} />

            <Route path="/Policy" element={<Policy />} />
            <Route path="/Organization" element={<Organization />} />

            <Route path="/System" element={<System />} />
            <Route path="/TicketCategory" element={<TicketCategory />} />
            <Route path="/TicketPriorityType" element={<TicketPriorityType />} />
            <Route path="/TicketStatusType" element={<TicketStatusType />} />
            <Route path="/SystemAuthority" element={<SystemAuthority/>} />
            <Route path="/ServerEnv" element={<ServerEnv />} />
            <Route path="/ServerConnType" element={<ServerConnType />} />

            <Route path="/SystemInfo" element={<SystemInfo />} />
          </Route>
          {/* <Route path="/" element={<RouterOutlet />} /> */}
        </Routes>
      )}
    </div>
  );
}

// const RouterOutlet = () => {
//   return (
//     <Router>
//       <Switch>
//         <Route path="/" element={<OrganizationListTable />} />
//         <Route path="/system-used-selection" element={<SystemUsedSelectionPage />} />
//       </Switch>
//     </Router>
//   );
// };

export default App;
